import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import BarraAreaAlunoRelatorio from "../../components/BaraAreaAlunoRelatorio/BaraAreaAlunoRelatorio";
import DateChanger from "./components/DateChanger/DateChanger";
import TabelaCalendario from "./components/TabelaCalendario/TabelaCalendario";
import TabelaCalendarioMobile from "./components/TabelaCalendario/TabelaCalendarioMobile";

import styles from "./Calendario.module.scss";

export default function Calendario() {
    const { id: turmaId } = useParams();

    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

    const [dynamicColumns] = useState([]);
    const [dados] = useState([]);
    const [data, setData] = useState(new Date());

    const handlerClickData = data => {
        setData(data);
    };

    return (
        <div className={styles.calendario}>
            <div className="background-layer" />
            <div className={styles.titulo}>
                <h1> ÁREA DO ALUNO</h1>
            </div>

            <BarraAreaAlunoRelatorio title={"CALENDÁRIO DE AULAS"} code={turmaId} />

            <DateChanger nome={localStorage.getItem("nome")} alterarData={handlerClickData} data={data}></DateChanger>

            {isTabletOrMobile ? (
                <div>
                    <TabelaCalendarioMobile
                        dynamicColumns={dynamicColumns}
                        disciplinas={dados}
                        alterarData={handlerClickData}
                        data={data}
                    />
                </div>
            ) : (
                <div className={styles.tabelaDesktop}>
                    <TabelaCalendario dynamicColumns={dynamicColumns} disciplinas={dados} alterarData={handlerClickData} data={data} />
                </div>
            )}
        </div>
    );
}
